import { useLinkTo } from '@react-navigation/native';
import { Image, ImageBackground, StyleSheet, Text, View } from 'react-native';
import QRCode from 'react-native-qrcode-svg';
import theme from 'theme';
import { calcSizeForTv } from 'utils/index';

import logoHeader from 'assets/LogoHeader.png';
import appStoreBadge from 'assets/app-store-badge.png';
import backgroundImage from 'assets/error-background-desktop.png';
import googlePlayBadge from 'assets/google-play-badge.png';

import Button from 'components/Button';
import { WebDiv } from 'components/WebDiv';

const APP_LINK = 'https://qrco.de/bgvkVR';
const QR_SIZE = calcSizeForTv(400);
const BADGE_WIDTH = calcSizeForTv(200);

const STORES = [
  { label: 'Disponível na App Store', badge: appStoreBadge },
  { label: 'Disponível no Google Play', badge: googlePlayBadge },
];

export const WatchOnApp: React.FC = () => {
  const linkTo = useLinkTo();

  return (
    <ImageBackground source={backgroundImage} style={styles.background}>
      <View style={styles.content}>
        <Image source={logoHeader} style={styles.logo} resizeMode="contain" />

        <Text style={styles.title}>
          {/* Para acessar o conteúdo vertical, escaneie o QR Code abaixo e baixe o app Bandplay. */}
          Conteúdo exclusivo para dispositivos móveis. Baixe o Bandplay no seu celular e assista aos
          Minidramas.
        </Text>

        {/* <View style={styles.qrWrapper}>
          <QRCode value={APP_LINK} size={QR_SIZE} backgroundColor="#070D31" color="#A8B4FF" />
        </View> */}

        <View style={styles.stores}>
          {STORES.map(({ label, badge }) => (
            <Image
              key={label}
              source={badge}
              accessibilityLabel={label}
              resizeMode="contain"
              style={styles.badge}
            />
          ))}
        </View>

        <WebDiv className="rounded-8">
          <Button
            role="button"
            useTVFocus
            hasTVPreferredFocus
            variant="solid"
            iconType="ArrowLeft"
            iconStyle={{ color: '#070D31' }}
            backgroundColor="#A8B4FF"
            borderColor="white"
            onPress={() => linkTo('/')}
            style={styles.backButton}
            textStyle={styles.backButtonText}>
            Voltar
          </Button>
        </WebDiv>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: calcSizeForTv(24),
  },
  logo: {
    width: calcSizeForTv(288),
    height: calcSizeForTv(63),
    marginBottom: calcSizeForTv(48),
  },
  title: {
    color: 'white',
    fontFamily: theme.fonts.inter.bold,
    fontSize: calcSizeForTv(36),
    lineHeight: calcSizeForTv(53),
    textAlign: 'center',
    maxWidth: calcSizeForTv(933),
    marginBottom: calcSizeForTv(40),
  },
  qrWrapper: {
    marginBottom: calcSizeForTv(24),
  },
  stores: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: calcSizeForTv(16),
    marginBottom: calcSizeForTv(32),
  },
  badge: {
    width: BADGE_WIDTH,
    height: BADGE_WIDTH / 2.87,
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: QR_SIZE,
    height: calcSizeForTv(54),
    borderRadius: 34,
  },
  backButtonText: {
    color: '#070D31',
    fontFamily: theme.fonts.inter.bold,
    fontSize: calcSizeForTv(20),
    marginLeft: 6,
  },
});
